import Vue from 'vue'
import Router from 'vue-router'
import FrontPage from '@/pages/FrontPage'
import ContactsPage from '@/pages/ContactsPage'
import AboutPage from '@/pages/AboutPage'
import ProjectsPage from '@/pages/ProjectsPage'
import ProjectDetailPage from '@/pages/ProjectDetailPage'
import DesignsPage from '@/pages/DesignsPage'
import ExperiencePage from '@/pages/ExperiencePage'
import ImageGalleryPage from '@/pages/ImageGalleryPage'
import VideoPlayer from '@/components/VideoPlayer'
import AdminHomePage from '@/admin_pages/AdminHomePage'
import LoginPage from '@/admin_pages/LoginPage'
import RegistrationPage from '@/admin_pages/RegistrationPage'
import AboutMenuItem from '@/admin_pages/AboutMenuItem'
import DesignMenuItem from '@/admin_pages/DesignMenuItem'
import ProjectsMenuItem from '@/admin_pages/ProjectsMenuItem'
import ExperienceMenuItem from '@/admin_pages/ExperienceMenuItem'
import CompletedDevMenuItem from '@/admin_pages/CompletedDevMenuItem'
import SliderImagesMenuItem from '@/admin_pages/SliderImagesMenuItem'
import ChooseImageGallery from '@/admin_pages/ChooseImageGallery'
import ImageGalleryMenuItem from '@/admin_pages/ImageGalleryMenuItem'
import ExperienceImageGalleryMenuItem from '@/admin_pages/ExperienceImageGalleryMenuItem'
import CompanyContactMenuItem from '@/admin_pages/CompanyContactMenuItem'
import SocialLinksMenuItem from '@/admin_pages/SocialLinksMenuItem'
import VideoGalleryMenuItem from '@/admin_pages/VideoGalleryMenuItem'
import NotFoundPage from '@/pages/NotFoundPage'
// const routerOptions = [
//   { path: '/', component: 'Home' },
//   { path: '/about', component: 'About' }
// ]

// const routes = routerOptions.map(route => {
//   return {
//     ...route,
//     component: () => import(`@/components/${route.component}.vue`)
//   }
// })

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'FrontPage',
      component: FrontPage
    },
    {
      path: '/contact',
      name: 'Contact',
      component: ContactsPage
    },
    {
      path: '/about',
      name: 'About',
      component: AboutPage
    },
    {
      path: '/works',
      name: 'Projects',
      component: ProjectsPage
    },
    {
      path: '/works/:name',
      name: 'Project Details',
      component: ProjectDetailPage
    },
    {
      path: '/design',
      name: 'Design',
      component: DesignsPage
    },
    {
      path: '/experience',
      name: 'Experience',
      component: ExperiencePage
    },
    {
      path: '/gallery',
      name: 'Image Gallery',
      component: ImageGalleryPage
    },
    {
      path: '/video-player',
      name: 'Video Player',
      component: VideoPlayer
    },
    {
      path: '/admin',
      name: 'Admin Home',
      component: AdminHomePage
    },
    {
      path: '/admin/login',
      name: 'Admin Login',
      component: LoginPage
    },
    {
      path: '/admin/register',
      name: 'Admin Register',
      component: RegistrationPage
    },
    {
      path: '/admin/about',
      name: 'Admin About Menu Items',
      component: AboutMenuItem
    },
    {
      path: '/admin/design',
      name: 'Admin Design Menu Items',
      component: DesignMenuItem
    },
    {
      path: '/admin/project',
      name: 'Admin Project Menu Items',
      component: ProjectsMenuItem
    },
    {
      path: '/admin/experience',
      name: 'Admin Experience Menu Items',
      component: ExperienceMenuItem
    },
    {
      path: '/admin/completed-dev',
      name: 'Admin Completed Menu Items',
      component: CompletedDevMenuItem
    },
    {
      path: '/admin/slider-images',
      name: 'Admin Slider Items',
      component: SliderImagesMenuItem
    },
    {
      path: '/admin/image-gallery',
      name: 'Admin Image Gallery Items',
      component: ChooseImageGallery
    },
    {
      path: '/admin/project-image-gallery',
      name: 'Admin Project Image Gallery Items',
      component: ImageGalleryMenuItem
    },
    {
      path: '/admin/experience-image-gallery',
      name: 'Admin Experience Image Gallery Items',
      component: ExperienceImageGalleryMenuItem
    },
    {
      path: '/admin/company-contact',
      name: 'Admin company contact Items',
      component: CompanyContactMenuItem
    },
    {
      path: '/admin/social-links',
      name: 'Admin Social Links Items',
      component: SocialLinksMenuItem
    },
    {
      path: '/admin/video-gallery',
      name: 'Admin Video Gallery Items',
      component: VideoGalleryMenuItem
    },
    // {
    //   path: '/awards',
    //   name: 'Awards',
    //   component: Awards
    // },
    // {
    //   path: '/sponsorship',
    //   name: 'Sponsorship',
    //   component: Sponsorship
    // },
    {
      path: '*',
      name: '404 Page',
      component: NotFoundPage
    }
  ],
  mode: 'history' // Removes '#/' from the URL
})



// WEBPACK FOOTER //
// ./src/router/index.js